export const pack = {
  create: "Créer un pack",
};
